import firebase from './firebase';

const firebaseGetUserProfile = async uid => {
  const userDoc = await firebase.firestore().collection('users').doc(uid).get();
  const userData = userDoc.data();
  return userData;
};

export default firebaseGetUserProfile;
